export default __webpack_public_path__ + "static/media/Rise_entry.93fd24ca.jpg";